import { useCallback } from 'react';
import useSWR from 'swr';
import { CACHE_KEYS } from '../utils/CacheUtils.js';
/**
 * @param publishedClient
 * @param query If `undefined`, no data is fetched
 * @param options
 */
export function usePublishedEntitiesSample(publishedClient, query, options) {
    const fetcher = useCallback(([_action, query, options]) => fetchEntitiesSample(publishedClient, query, options), [publishedClient]);
    const { data, error } = useSWR(query ? CACHE_KEYS.publishedEntitiesSample(query, options) : null, fetcher);
    // useDebugLogChangedValues('usePublishedEntitiesSample updated values', { publishedClient, query, options, data, error, });
    return { entitiesSample: data, entitiesSampleError: error };
}
async function fetchEntitiesSample(publishedClient, query, options) {
    const result = await publishedClient.getEntitiesSample(query, options);
    if (result.isError()) {
        throw result; // throw result, don't convert to Error
    }
    return result.value;
}
//# sourceMappingURL=usePublishedEntitiesSample.js.map